const jobTopicOptions = [
  {
    key: 'Sales',
    text: 'Sales/Partnership Expansion',
    value: 'Sales',
  },
  {
    key: 'Support',
    text: 'Existing Partner Support',
    value: 'Support',
  },
];

export default jobTopicOptions;
